// Enabler E7-C (ADO-2274), D-1: the ordering entry every catalogue read names.
//
// Search and browse show only the range of the entry the store selected, so each catalogue
// request carries `useSessionStore.activeEntryKey`. With no active entry there is nothing to ask
// for: a store user is sent to `/choose` first (Story 8.1's browsing gate), and for staff the entry
// follows the depot they pick. A caller that finds no entry makes no catalogue call.

import { useSessionStore } from '../auth/useSessionStore';

/** The active ordering entry's key, or `null` when none is chosen. A point-in-time read. */
export function resolveCatalogueEntryKey(): string | null {
  return useSessionStore.getState().activeEntryKey;
}

/**
 * The active ordering entry's key as a SUBSCRIBED value: the component re-renders, and any
 * effect declaring it re-runs, when the entry changes.
 */
export function useCatalogueEntryKey(): string | null {
  return useSessionStore((s) => s.activeEntryKey);
}
